var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoyid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 122 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6701 17.944C29.0503 19.154 27.8048 20.7964 27.0768 22.6826L19.8499 43.8245L7.41715 34.8728C6.46943 34.1901 4.98271 34.3517 3.78346 35.2635L0.60791 37.7025L3.96761 76.8376L13.2562 55.6104L30.4904 51.4916L51.1292 2.32227L30.6701 17.944Z",
    fill: "url(#paint0_linear_481_9695)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8499 43.8245L27.0768 22.6826C27.8048 20.7964 29.0503 19.154 30.6701 17.944L51.1292 2.32227L30.4904 51.4916M19.8499 43.8245L7.41715 34.8728C6.46943 34.1901 4.98271 34.3518 3.78346 35.2635L0.60791 37.7025M19.8499 43.8245L30.4904 51.4916M0.60791 37.7025L3.96761 76.8376L13.2562 55.6104M0.60791 37.7025L13.2562 55.6104M13.2562 55.6104L30.4904 51.4916",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27102 34.9456L7.27104 34.9456L29.9013 51.2453L13.3627 55.1978L0.950682 37.6244L3.93477 35.3325C3.93493 35.3324 3.93509 35.3322 3.93525 35.3321C5.08006 34.462 6.44237 34.3486 7.27102 34.9456Z",
    fill: "#D2FF00",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3004 50.6025H48.753L46.077 65.9767C45.2149 70.8317 41.8461 73.4072 37.3983 73.4072C32.8077 73.4072 30.0629 70.7047 30.9567 65.6223H36.3776C36.0285 67.5527 36.7002 68.4835 38.1017 68.4835C39.408 68.4835 40.3018 67.6479 40.6191 65.9767L43.3004 50.6025Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3314 73.4393C52.6773 73.4393 49.52 70.4459 49.52 65.9135C49.52 59.7046 54.2058 54.9766 60.5204 54.9766C65.1797 54.9766 68.4005 58.0017 68.4005 62.534C68.4111 68.8064 63.5826 73.4393 57.3314 73.4393ZM58.0982 68.7112C60.9065 68.7112 62.7522 65.85 62.7522 63.047C62.7522 60.7994 61.3825 59.7046 59.7218 59.7046C56.8871 59.7046 55.1313 62.5658 55.1313 65.4269C55.1313 67.6164 56.4059 68.7112 58.0982 68.7112Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6636 55.2354H76.7191L78.8928 66.4579L84.9483 55.2354H90.8504L75.0638 81.6786H69.1934L74.8734 72.5451L70.6636 55.2354Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6215 50.6025H99.0847L95.1288 73.1798H89.6709L93.6215 50.6025Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.181 61.8938C120.002 68.5787 114.608 73.1798 107.468 73.1798H99.0854L103.036 50.6025H111.424C118.564 50.6025 122.356 55.1719 121.181 61.8938ZM107.96 68.4835C112.074 68.4835 114.946 66.0401 115.644 61.8938C116.342 57.7475 114.386 55.3147 110.271 55.3147H107.658L105.363 68.4993L107.96 68.4835Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_481_9695",
    x1: 48.6079,
    y1: 4.82227,
    x2: 3.60791,
    y2: 77.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553964,
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669968,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847555,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoyid);
export default __webpack_public_path__ + "static/media/joyid.eb415b6e893d88092bf320090988f25b.svg";
export { ForwardRef as ReactComponent };